import {Link} from 'react-router-dom';
import React from 'react';

import {putApi, dateLocal, dateUTCLocal, dateLocalUTC} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
import moment from 'moment';
import Genres from '../genres/genres';
import ScheduleEdit from './edit';
import CopyBox from '../bbcode/copybox';
//import { allTimezones } from "react-timezone-select";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Form from 'react-bootstrap/Form';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
//import DropdownButton from 'react-bootstrap/DropdownButton';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';
//import { ButtonGroup } from 'react-bootstrap';

import './scheduler.css';

import getValue from './confirm';


/*
	This will be the mini version for the dashboard page
*/
export default class DJAreaScheduler extends React.Component {
	static contextType = UserContext;
	constructor(props) {
		super(props);

		

		this.state = {
			version: this.props.version,
			service: parseInt(this.props.service),
			event: this.props.event,
			dragHover: {type: -1, sid: 0, uid: -1, original: 0, hour: -1, period: 0, ctime: 0},
			prepare: {
				djs: [],
				genres: [],
				replays: []
			},
			recordings: false,
			scheduleedit: {
				organiser: false, id: false
			},
			loop_outer: [],
			loop_inner: [],
			loop_block: 2,

			date_dj: 0,
			Schedule: null,
			Scroll: 0,
			posstart: dateLocalUTC(this.props.event.start),
			posend: dateLocalUTC(this.props.event.end),
			messenger: false,
			scheduletime: false,
			booking: {
				status: false,
				error: "",
			},
			timezones: {
				selected: this.props.event.zone,
				zones: []
			}
		};
		this.handleScroll = this.handleScroll.bind(this);
		//consoleLog(this.props.event);
		this.prepareTimings = this.prepareTimings.bind(this);
		this.scheduleHold = this.scheduleHold.bind(this);
		this.schedulerHover = this.schedulerHover.bind(this);
		this.schedulerDrop = this.schedulerDrop.bind(this);
		this.touchHold = this.touchHold.bind(this);
		this.touchMove = this.touchMove.bind(this);


		this.addEvent = this.addEvent.bind(this);
		this.changeEvent = this.changeEvent.bind(this);
		this.scheduleEdit = this.scheduleEdit.bind(this);

		this.increaseStart = this.increaseStart.bind(this);
		this.increaseEnd = this.increaseEnd.bind(this);

		this.replay = this.replay.bind(this);
		this.messenger = this.messenger.bind(this);
		this.scheduleTime = this.scheduleTime.bind(this);
		this.booking = this.booking.bind(this);

		this.recordings = this.recordings.bind(this);
		
	}

	async componentDidMount() {

		let user = this.context;
		await this.prepareTimings();
		await this.prepareTimezones();
		

		const Schedule = EventEmitter.addListener(`/${this.state.service}/schedule2`, async data => {
			if( Object.keys(data.schedule).length > 0 ) {
				if( user.user.user.id !== data.uid && new Date(data.schedule.start) === new Date(this.state.event.start) && this.state.scheduleedit.organiser === false ) {
					
					//this.setState({event: data.schedule});
				}
			}
			

			//this.setState({meta: data});
		}); this.setState({Schedule});

		window.addEventListener('scroll', this.handleScroll, false);
	}

	componentDidUpdate(nextProps, nextState) {
		let x = new Date(this.state.event.date);
		let y = new Date(nextProps.event.date);
		
		if( x.getTime() !== y.getTime() && nextProps.event.date !== dateLocalUTC(nextProps.event.start) ) {
			//console.log("UPDATE!", nextProps.event.date);
			//console.log(nextProps.event);
			
			nextProps.event.date = dateLocalUTC(nextProps.event.start);
			nextProps.event.start = dateLocalUTC(nextProps.event.start);
			nextProps.event.end = dateLocalUTC(nextProps.event.end);
			for( let i in nextProps.event.events ) {
				nextProps.event.events[i].start = dateLocalUTC(nextProps.event.events[i].start);
				nextProps.event.events[i].end = dateLocalUTC(nextProps.event.events[i].end);
			}
			
			this.setState({event: nextProps.event, posstart: nextProps.event.start, posend: nextProps.event.end},async ()=>{
				await this.prepareTimings();
				await this.prepareTimezones();
			});
		}
		if( x.getTime() !== y.getTime() ) {
			this.setState({prepare: nextProps.prepare});
		}
		return true;
	}

	componentWillUnmount() {
		if( this.state.Schedule ) this.state.Schedule.remove();
		window.removeEventListener('scroll', this.handleScroll, false);
	}

	async prepareTimings() {
		const loop_outer = [];
		const loop_inner = [];

		//let date = new Date();
		let start = Math.floor(this.state.event.start.getTime()/1000);//Math.floor(new Date(this.state.event.start).getTime()/1000);
		let end = Math.floor(this.state.event.end.getTime()/1000);//Math.floor(new Date(this.state.event.end).getTime()/1000);
		const loop_block = this.state.event.length/30;

		for( let i = start; i < end; i = i + this.state.event.length*60) {
			loop_outer.push(i);
		}
		for( let i = start; i < end; i = i + this.state.event.length*60/loop_block) {
			loop_inner.push(i);
		}
		
		this.setState({loop_outer, loop_inner, loop_block });
	}


	async prepareTimezones() {
		let timezones = {
			selected: this.props.event.zone,
			zones: []
		};

		if( this.props.event.timezone !== Intl.DateTimeFormat().resolvedOptions().timeZone ) {
			let offset1 = new Intl.DateTimeFormat('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, timeZoneName: "shortOffset" }).formatToParts().filter(e => e.type === "timeZoneName")[0].value;
			timezones.zones.push({
				country: Intl.DateTimeFormat().resolvedOptions().timeZone,
				offset :offset1,
				hour: 
					Intl.DateTimeFormat('en-US', {
						timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
						hour: 'numeric',
						minute: 'numeric'
					})
			});
		}

		let offset2 = new Intl.DateTimeFormat('en-US', { timeZone: this.props.event.timezone, timeZoneName: "shortOffset" }).formatToParts().filter(e => e.type === "timeZoneName")[0].value;
		timezones.zones.push({
			country: this.props.event.timezone,
			offset: offset2,
			hour: 
				Intl.DateTimeFormat('en-US', {
					timeZone: this.props.event.timezone,
					hour: 'numeric',
					minute: 'numeric'
				})
		});

		this.setState({timezones});


		return;
		/*
		for( let i in allTimezones ) {
			if( i === Intl.DateTimeFormat().resolvedOptions().timeZone || i === this.props.event.timezone ) {
				
				
				//useTimezoneSelect({labelStyle: 'abbrev', timezones: []});

				let offset = new Intl.DateTimeFormat('en-US', { timeZone: i, timeZoneName: "shortOffset" }).formatToParts().filter(e => e.type === "timeZoneName")[0].value;

				

				timezones.zones.push({
					country: allTimezones[i],
					offset,
					hour: 
						Intl.DateTimeFormat('en-US', {
							timeZone: i,
							hour: 'numeric',
							minute: 'numeric'
						})
				});

			}
		}

		this.setState({timezones});

		//let time1 = Intl.DateTimeFormat().resolvedOptions().timeZone;

		//let time2 = this.props.event.timezone;

		*/
	}

	handleScroll(event) {
		this.setState({Scroll: Date.now()});
	}

	scheduleHold(event, type, sid, uid, hour, period) {
		
		//if( Date.now() < this.state.Scroll + 250 ) return;

		
		if( this.state.dragHover.type === -1 ) {
			
			let dragHover = this.state.dragHover;
			dragHover.type = type;
			dragHover.sid = sid;
			dragHover.uid = uid;
			dragHover.original = hour;
			dragHover.hour = hour;
			dragHover.period = period;
			this.setState({dragHover});
			
		}
	}

	schedulerHover(event) {
		event.preventDefault();
		let hour = false;
		let objects = document.elementsFromPoint(event.clientX, event.clientY);
		for( let i in objects ) {
			if( parseInt(objects[i].id) ) hour = parseInt(objects[i].id);
		}
		if( isNaN(hour) ) return;
		if( this.state.dragHover.type === 0 ) {
			if( hour !== this.state.dragHover.hour ) {
				let dragHover = this.state.dragHover;
				dragHover.hour = hour;
				let event = {...this.state.event};
				for( let i in event.events ) {
					if( event.events[i].id === this.state.dragHover.sid ) {
						


						let start = new Date(hour*1000);
						let end = Math.floor(new Date(hour*1000).getTime()/1000 ) + Math.floor(new Date(event.events[i].end).getTime()/1000) - Math.floor(new Date(event.events[i].start).getTime()/1000);
						event.events[i].start = start;
						event.events[i].end = end;
						
						
					}
				}
				this.setState({dragHover, event});
			}
		} else if( this.state.dragHover.type === 1 ) {
			if( hour !== this.state.dragHover.hour + this.state.dragHover.period*1800 - 1800 ) {
				
				let dragHover = {...this.state.dragHover};
				dragHover.period = Math.ceil((hour - this.state.dragHover.hour)/1800) + 1;
				if( dragHover.period < 1 ) dragHover.period = 1;
				let event = {...this.state.event};
				for( let i in event.events ) {
					if( event.events[i].id === this.state.dragHover.sid ) {
						event.events[i].end = new Date((dateLocal(event.events[i].start) + dragHover.period * 1800)*1000);
					}
				}
				this.setState({dragHover, event});
			}
		}
	}

	

	async schedulerDrop(event) {
		event.preventDefault();
		let dragHover = {...this.state.dragHover};
		let permanent = 0;
		let sid = this.props.event.events.find(elem=>elem.id===dragHover.sid);
		if( sid && sid.recurring === 1 ) {
			permanent = await getValue("Is this a permanent change?", sid.avatar, sid.title?sid.title:sid.username, dragHover.original, dragHover.hour);
			if( permanent === 0 ) {
				this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
				this.close();
				return;
			}
		}

		if( this.state.dragHover.type === 0 ) {
			let params = new URLSearchParams();
			params.append('service', this.state.service);
			params.append('id', dragHover.sid);
			params.append('dj', dragHover.uid);
			params.append('start', dragHover.hour );
			params.append('end', dragHover.hour + dragHover.period*1800 );
			params.append('showname', this.state.event.showname);
			params.append('permanent', permanent);
			this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
			let z = await putApi(`${this.context.worker[this.props.service]}/v3/service/schedule/${dragHover.sid}`, params);
			if( z.status === 212 || z.status === 217 ) this.booking(); else this.close();
		} else if( this.state.dragHover.type === 1 ) {
			
			let events = {...this.state.event.events};
			for( let i in events ) {
				if( dragHover.sid === events[i].id ) {
					let params = new URLSearchParams();
					params.append('service', this.state.service);
					params.append('id', dragHover.sid);
					params.append('dj', dragHover.uid);
					params.append('start', dragHover.hour );
					params.append('end', dragHover.hour + dragHover.period*1800 );
					params.append('showname', this.state.event.showname);
					params.append('permanent', permanent);
					this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
					let z = await putApi(`${this.context.worker[this.props.service]}/v3/service/schedule/${dragHover.sid}`, params);
					if( z.status === 212 || z.status === 217 ) this.booking(); else this.close();
				}
			}
			this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
		}
	}


	touchHold(event, hour) {
		event.preventDefault();
		let dragHover = this.state.dragHover;
		let events = {...this.state.event.events};
		if( dragHover.type !== -1 ) return;
		if( Date.now() < this.state.Scroll + 250 ) return;
		let object = document.elementFromPoint(event.touches[0].clientX, event.touches[0].clientY);
		let id = parseInt(object.id.slice(1));

		if( isNaN(id) ) {
			for( let i in events ) {
				if( Math.floor(new Date(events[i].start)/1000) === hour ) {
					let past = (Date.now() > new Date(events[i].end*1000));
					if( past ) return;
					dragHover.ctime = Math.floor(Date.now());
					dragHover.type = 0;
					dragHover.sid = events[i].id;
					dragHover.uid = events[i].uid;
					dragHover.original = hour;
					dragHover.hour = hour;
					dragHover.period = Math.floor((dateLocal(events[i].end)-dateLocal(events[i].start))/1800);
					this.setState({dragHover});
					
				}
			}
		} else {
			for( let i in events ) {
				if( events[i].id === id ) {
					let past = (Date.now() > new Date(events[i].end*1000));
					if( past ) return;
					dragHover.type = 1;
					dragHover.sid = events[i].id;
					dragHover.uid = events[i].uid;
					dragHover.hour = hour;
					dragHover.period = Math.floor((dateLocal(events[i].end)-dateLocal(events[i].start))/1800);
					this.setState({dragHover});
				}
			}
		}
	}

	touchMove(event) {
		if( event.pointerType !== 'touch') return;
		event.preventDefault();

		let hour = false;
		let objects = document.elementsFromPoint(event.clientX, event.clientY);
		for( let i in objects ) {
			if( parseInt(objects[i].id) ) hour = parseInt(objects[i].id);
		}
		
		//let object = document.elementFromPoint(event.clientX, event.clientY);
		
		//let hour = parseInt(object.id);
		if( isNaN(hour) ) return;
		
		//return;
		
		let dragHover = {...this.state.dragHover};
		if( this.state.dragHover.type === 0 ) {

			if( Math.floor(Date.now()) > dragHover.ctime + 500 && dragHover.hour !== hour ) {
				dragHover.hour = hour;
				/*
				let event = {...this.state.event};
				for( let i in event.events ) {
					if( event.events[i].id === this.state.dragHover.sid ) {
						let start = new Date(hour*1000);
						let end = Math.floor((hour+dragHover.period*1800)*1000);
						event.events[i].start = start;
						event.events[i].end = end;
					}
				}
				*/
				
				this.setState({dragHover});
			}
		} else if( this.state.dragHover.type === 1 ) {

			if( hour !== dragHover.hour + dragHover.period*1800 - 1800 ) {
				dragHover.period = Math.ceil((hour - this.state.dragHover.hour)/1800) + 1;

				this.setState({dragHover});
			}
			
/*
			if( hour !== this.state.dragHover.hour + this.state.dragHover.period - 1 ) {
				let dragHover = this.state.dragHover;
				dragHover.period = hour - this.state.dragHover.hour + 1;
				if( dragHover.period < 1 ) dragHover.period = 1;
				
				
				let event = {...this.state.event};
				for( let i in event.events ) {
					if( event.events[i].id === this.state.dragHover.sid ) {
						event.events[i].end = event.events[i].start + dragHover.period * 1800;
					}
				}
				
				this.setState({dragHover, event});
			}
*/
		}
		

	}

	async touchDrop(event) {
		//event.preventDefault();
		
		
		

		//let object = document.elementFromPoint(event.clientX, event.clientY);
		//let hour = parseInt(object.id);
		

		let dragHover = this.state.dragHover;

		if( Math.floor(Date.now()) < dragHover.ctime + 500 ) {
			this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
			return;
		}
		
		if( this.state.dragHover.type === 0 ) {
			//let start = Math.floor(dateUTC(dragHover.hour*1000).getTime()/1000);
			//let end = Math.floor(dateUTC((dragHover.hour+dragHover.period*1800)*1000).getTime()/1000);
			
			//return;
			
			let event = {...this.state.event};
			for( let i in event.events ) {
				if( event.events[i].id === this.state.dragHover.sid ) {
					let start = new Date(dragHover.hour*1000);
					let end = new Date(Math.floor((dragHover.hour+dragHover.period*1800)*1000));
					event.events[i].start = start;
					event.events[i].end = end;
					if( Math.floor(new Date(event.events[i].start)/1000) === dragHover.hour && Math.floor(new Date(event.events[i].end)/1000)/*, Math.floor(dragHover.hour+dragHover.period*1800)*/ ) {
						this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
						//return;
					}
				}
			}
				
			let params = new URLSearchParams();
			params.append('service', this.state.service);
			params.append('id', dragHover.sid);
			params.append('dj', dragHover.uid);
			params.append('start', dragHover.hour);
			params.append('end', dragHover.hour + dragHover.period*1800 );
			params.append('showname', this.state.event.showname);
			this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
			let z = await putApi(`${this.context.worker[this.props.service]}/v3/service/schedule/${dragHover.sid}`, params);
			if( z.status === 212 || z.status === 217 ) this.booking(); else this.close();
		} else if( this.state.dragHover.type === 1 ) {
			let events = {...this.state.event.events};
			for( let i in events ) {
				if( dragHover.sid === events[i].id ) {

					let event = {...this.state.event};
					for( let i in event.events ) {
						if( event.events[i].id === this.state.dragHover.sid ) {
							let start = new Date(dragHover.hour*1000);
							let end = new Date(Math.floor((dragHover.hour+dragHover.period*1800)*1000));
							event.events[i].start = start;
							event.events[i].end = end;
						}
					}

					let params = new URLSearchParams();
					params.append('service', this.state.service);
					params.append('id', dragHover.sid);
					params.append('dj', dragHover.uid);
					params.append('start', dragHover.hour);
					params.append('end', dragHover.hour + dragHover.period*1800 );
					params.append('showname', this.state.event.showname);
					this.setState({dragHover: {type: -1, uid: -1, sid: 0, hour: -1, period: 0, ctime: 0}});
					let z = await putApi(`${this.context.worker[this.props.service]}/v3/service/schedule/${dragHover.sid}`, params);
					if( z.status === 212 || z.status === 217 ) this.booking(); else this.close();
				}
			}
		}
		
	}


	async addEvent(date) {
		if( date === 0 ) {
			this.setState({date_dj: 0});
		} else {
			let params = new URLSearchParams();
			params.append('service', this.state.service);
			params.append('title', '');
			params.append('start', date);
			params.append('end', date+(this.state.event.length*60));
			params.append('genres', '');
			params.append('recurring', 0);
			params.append('showname', this.state.event.showname);
			const x = await putApi(`${this.context.worker[this.props.service]}/v3/service/schedule`, params);
			if( x.status === 200 ) this.props.close(); else this.booking();
		}
	}

	async addEventDJ(date, id, syndicate = 0) {
		if( date === 0 ) return;
		let params = new URLSearchParams();
		params.append('service', this.state.service);
		params.append('dj', id);
		params.append('title', '');
		params.append('start', date);
		params.append('end', date+(this.state.event.length*60));
		params.append('genres', '');
		params.append('recurring', 0);
		params.append('showname', this.state.event.showname);
		params.append('syndicate', syndicate);
		const x = await putApi(`${this.context.worker[this.props.service]}/v3/service/schedule`, params);
		if( x.status === 200 ) this.close();
	}

	async changeEvent(date, id) {
		
	}

	scheduleEdit(e) {
		this.setState({scheduleedit: {organiser: true, id: e}});
	}

	close = (childData) => {
    this.setState({scheduleedit: {organiser: false, id: false}, date_dj: 0}, () => {
			this.props.close();
		});
	}

	async increaseStart() {
		let event = this.state.event;
		let start = this.state.posstart;
		for( let i in event.events ) {
			let date = new Date(event.events[i].start);
			if( date < start ) start = date;
		}
		event.start = dateUTCLocal(new Date((Math.floor(start.getTime()/1000) - 3600 * (this.state.loop_block===3?3:4))*1000));
		this.setState({event}, ()=>{
			this.prepareTimings();
		});
	}

	async increaseEnd() {
		let event = this.state.event;
		let end = this.state.posend;
		for( let i in event.events ) {
			let date = new Date(event.events[i].end);
			if( date > end ) end = date;
		}
		event.end = new Date((Math.floor(end.getTime()/1000) + 3600 * (this.state.loop_block===3?3:4))*1000);
		this.setState({event},()=>{
			this.prepareTimings();
		});
	}

	async replay(id) {
		let audioState = {
			id,
			currentTime: 0,
			duration: 0,
			buffered: 0,
			pause: false,
			replay: false,
			repeat: false,
			favorite: false,
			like: false,
		};
		EventEmitter.emit('/audio/player', audioState);
	}

	messenger() {
		this.setState({messenger: !this.state.messenger});
	}

	async scheduleTime(save = false) {
		if( save ) {
			const scheduleStart = document.querySelector('input[name="schedule-starttime"]:checked').value;
			const scheduleEnd = document.querySelector('input[name="schedule-endtime"]:checked').value;
			let params = new URLSearchParams();
			params.append('id', this.state.event.id);
			params.append('event', this.state.event.eid);
			params.append('start', scheduleStart);
			params.append('end', scheduleEnd);
			await putApi('/api/v2/schedule/times', params);
			this.props.close();
			return;
		}
		this.setState({scheduletime: !this.state.scheduletime});
	}

	booking() {
		let booking = this.state.booking;
		booking.status = !booking.status;
		this.setState({booking});
		if( !booking.status ) this.close();
	}

	recordings(recordings) {
		this.setState({recordings});
	}

	render() {
		const user = this.context;
		

		/*

			so how are we handling the timezones?
			ideally if both timezones are the same then nothing more can be done

			selected: 0 = both, 1 = host, 2 = own



		*/
		
		


		//---- Checks if time local to Australia/Perth
		/*let hour = Intl.DateTimeFormat('en-US', {
			timeZone: "Australia/Perth",
			hour: 'numeric',
			hourCycle: 'h23'
		});
		let time = Intl.DateTimeFormat('en-US', {
			timeZone: "Australia/Perth",
			hour: 'numeric',
			minute: 'numeric'
		});
		
		let dateCheck = new Date();
		let check = parseInt(hour.format(dateCheck));
		let isLocal = dateCheck.getHours() === check;
		let zone = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];*/

		/*
		let timezone = Intl.DateTimeFormat('en-US', {
			timeZone: "Australia/Perth",
			timeZoneName: 'short'
			
		});
		
		*/
		

		//---- User permissions
		//let owner = false; // this you cant because its each individual set
		//let organiser = this.state.event.isOrganiser || false;
		//let admin = user.user.admin?.radioAdmin || user.user.admin?.radioAdmin || user.user.admin?.support || user.user.admin?.technician || user.user.admin?.owner || false;

		let rank = 0;
		let show = false;
		const djs = this.state.prepare.djs.map((e,i) => {
			if( e.id_level !== rank ) {
				show = true;
				rank = e.id_level;
			} else {
				show = false;
			}
			return (
				<React.Fragment key={i}>
					{show &&
						<Dropdown.Item eventKey={e.id} disabled={true}>
							{rank>=40 &&<><u><FontAwesomeIcon icon="user" /> Owner</u></>}
							{rank>=30 && rank<40 &&<><u><FontAwesomeIcon icon="user" /> Admin(s)</u></>}
							
							{rank>=20 && rank<30 &&<><u><FontAwesomeIcon icon="user" /> Radio DJ(s)</u></>}
						</Dropdown.Item>
					}
					<Dropdown.Item eventKey={e.id} onClick={()=>this.addEventDJ(this.state.date_dj, e.id)}>
						<Row>
							<div style={{width: 44}}>
								<img src={`https://cloud.ultrastream.io${e.avatar}`} width={28} height={28} style={{borderRadius: '50%'}} alt="Client Avatar" />
							</div>
							<Col style={{paddingTop: 4}}>
								{e.title ?
									<>
										{e.title} - ({e.username})
									</>
								:
									<>
										{e.username}
									</>
								}
							</Col>
						</Row>
						
						
					</Dropdown.Item>
				</React.Fragment>
			)
    })
		const replays = this.state.prepare.replays.map((e,i) => {
			let date = new Date(null);
			date.setSeconds(e.length); // specify value for SECONDS here
			let result = date.toISOString().substr(11, 8);
			return (
				<Dropdown.Item key={i} eventKey={e.id} onClick={()=>this.addEventDJ(this.state.date_dj, e.uid, e.id)}>
					<Row>
						<div style={{width: 138}}>
							<img src={e.png} width={124} style={{borderRadius: 5}} alt="Video Png" />
						</div>
						<Col style={{paddingTop: 4}}>
							{e.showname}<br />
							{e.title ?
								<>
									{e.title} - ({e.username})
								</>
							:
								<>
									{e.username}
								</>
							}<br />
							Running Time: {result}
						</Col>
					</Row>
				</Dropdown.Item>
			)
		});

		const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
			<span
				href=""
				ref={ref}
				onClick={(e) => {
					e.preventDefault();
					onClick(e);
				}}
				style={{color: '#000000 !important', cursor: 'pointer', display: 'inline-block', width: '100%'}}
			>
				{children}
				&nbsp;
				<div style={{position: 'absolute', right: 0, top: 0}}>
					&#x25bc;
				</div>
			</span>
		));

		const CustomMenu = React.forwardRef(
			({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
				//const [value, setValue] = useState('');
		
				return (
					<div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
						<ul className="list-unstyled" style={{width: 300}}>
							{React.Children.toArray(children).filter(
								(child) => child.props.children,
							)}
						</ul>
					</div>
				);
			},
		);

		const zones = this.state.timezones.zones.map((e,i) => {
			//let dateCheck = new Date();
			return (
				<React.Fragment key={i}>
					{(this.state.timezones.selected === 0 || this.state.timezones.selected === i+1) &&
						<>
							<div className="scheduler-intervals" style={{width: true?300:150}}>
					
						
								<div className="scheduler-date" style={{height:40}}>
									
										{((i===0 && this.state.timezones.zones.length === 2) || this.state.timezones.selected===2) ?
											<Dropdown style={{display: 'inline-block', width: '100%'}}>
												<Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
													
													{/*<b>({e.offset==='GMT'?'GMT+0':e.offset})</b><br />*/}
													<b>{e.country}</b>
												</Dropdown.Toggle>
												<Dropdown.Menu as={CustomMenu}>
													{(() => {
														return this.state.timezones.zones.map((f,j) => {
															return (
																<Dropdown.Item key={j} eventKey="1" onClick={()=>this.props.changeZone(j+1)}><FontAwesomeIcon icon="check" style={{color: this.state.timezones.selected===j+1?'#008800':'#ffffff'}} /> <b>({f.offset==='GMT'?'GMT+0':f.offset})</b> {f.country}</Dropdown.Item>
															)
														})
													})()}
													<Dropdown.Item eventKey="1" onClick={()=>this.props.changeZone(0)}><FontAwesomeIcon icon="check" style={{color: this.state.timezones.selected===0?'#008800':'#ffffff'}} /> Both</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
										:
											<div>
												
												{/*<b>({e.offset==='GMT'?'GMT+0':e.offset})</b><br />*/}
												<b>{e.country}</b>
											</div>
										}
										
									
								</div>
								{(() => {
									return (
										<>
											{this.state.loop_outer.map((f,j) => {
												return (
													<div key={j} className="scheduler-date">{e.hour.format(f*1000)}</div>
												)
											})}
										</>
									)
								})()}
						
					
								<div className="scheduler-date" style={{height:40}}></div>
							</div>
						</>
					}
				</React.Fragment>
			)
		})
		
		/*const outer_perth = 
      Object.keys(this.state.loop_outer).map((e,i) => {
				let prime = false;
				let date = new Date(this.state.loop_outer[e]*1000);
				if( this.state.event.length === 60 && date.getUTCHours() >= 10 && date.getUTCHours() < 14 ) prime = true;
				let perthStart = time.format(date);
				return (
					<div key={i} className={`scheduler-date ${prime===true&&'scheduler-prime'}`}>
						<OverlayTrigger placement="top" key={`time-${i}`} overlay={<Tooltip id={`time${i}`}>Time in Perth/Australia</Tooltip>}>
							<span>{perthStart}</span>
						</OverlayTrigger>
					</div>
				)
			})*/
		const inner_djs = Object.keys(this.state.loop_inner).map((e,i) => {

			let prime = false;
			//if( this.state.event.length === 60 && _prime.getUTCHours() >= 10 && _prime.getUTCHours() < 14 ) prime = true;

			
			let capture = (this.state.loop_inner[e] >= this.state.dragHover.hour && this.state.loop_inner[e] < this.state.dragHover.hour+this.state.dragHover.period*1800);
			

			return (
				

				<div
					key={this.state.loop_inner[e]}
					id={this.state.loop_inner[e]}
					className={`scheduler-tile scheduler-tile-bg scheduler-tile-${this.state.loop_block} ${capture===true&&'schedule-tile-hover'} ${prime===true&&'scheduler-prime'}`}
					onDrop={(e)=>this.schedulerDrop(e)}
					onDragOver={(e)=>this.schedulerHover(e)}
					
					onPointerMove={(f)=>this.touchMove(f)}
					onTouchEnd={(f)=>this.touchDrop(f)}
				>

					{(() => {
						let found = false;
						const y = this.state.event.events.map((g,k) => {

							let date = Math.floor(dateLocal(g.start)/1800)*1800;
							let owner = (g.uid===user.user.user.id || this.state.prepare.isAdmin===true) ? true : false;
							let past = (Math.floor(Date.now()/1000) > this.state.loop_inner[e]);

							//let pdate = new Date(g.start);
							//let perthStart = time.format(pdate);

							let length = [Math.abs( Math.floor(new Date(g.end)/1000 ) - Math.floor(new Date(g.start)/1000 ) ) / 60, 'minutes'];
							if( length[0] >= 120 ) {
								length[0] = length[0]/60;
								length[1] = 'hours';
							}

							//---- Ensure there are no sets around the time
							if( this.state.loop_inner[e] % 3600 === 0 /*|| this.state.loop_inner[e] % 1800 === 0*/ ) {
								let _date = dateLocal(this.state.loop_inner[e]*1000);
								
								if( _date > dateLocal((g.start)) && _date <= dateLocal(g.start) + 1800 && g.cancelled===0 ) {
									found = true;
								}
							}

							//---- Avatar
							if( g.avatar && g.avatar.indexOf('https://') !== 0 ) {
								g.avatar = `https://cloud.ultrastream.io${g.avatar}?d=${Math.floor(Date.now()/1000)}`;
							}

							if( date === this.state.loop_inner[e] ) {
								found = true;
								return (
									
									<div
										key={g.id}
										className={`${past===true||owner===false?'scheduler-tile-object-disabled':'scheduler-tile-object'} schedule-${this.state.version}`}
										draggable={!past&&owner===true?true:false}
										onDragStart={!past&&owner===true?(f)=>this.scheduleHold(f, 0, g.id, g.uid, date, Math.ceil((dateLocal(g.end) - dateLocal(g.start))/1800)):()=>{}}
										onTouchStart={!past&&owner===true?(f)=>this.touchHold(f, this.state.loop_inner[e]):()=>{}}
										style={{height: Math.ceil((dateLocal(g.end)-dateLocal(g.start))/60/30)*(this.state.loop_block===2?55:this.state.loop_block===3?36:27.5)-10/*, width: this.state.dragHover.type===-1?400:100*/}}
									>
										<div id={`s${g.id}`} className="scheduler-tile-inner">
										<div className={`card card-info card-outline mb-0 ${g.cancelled===1?'scheduler-tile-inner-cencalled':''}`} style={{height: '100%'}}>
											<div className={`card-header card-header-info p-0`}>
												<div className={`row gx-0 p-1 ps-2 ${g.uid===user.user.user.id?'schedule-owner':'schedule-grey'}`}>
													<div className="col-9">
														{/*<OverlayTrigger placement="top" key="overlay-5" overlay={<Tooltip id="tooltip5">Time in Perth/Australia</Tooltip>}>*/}
															<span>{moment(g.start).format("h:mm A")} - {moment(g.end).format("h:mm A")} {g.syndicate>0&&' (Replay)'}</span>
															
														{/*</OverlayTrigger>*/}
													</div>
													<div className="col">
														
														<div className="scheduler-tile-extended">
															{parseInt(g.pid) > 0 &&
																<>
																	<OverlayTrigger placement="top" key="overlay-1" overlay={<Tooltip id="tooltip1">Replay {g.showname}</Tooltip>}>
																		<FontAwesomeIcon icon="play" onClick={()=>this.replay(g.pid)} />
																	</OverlayTrigger>&nbsp;&nbsp;
																</>
															}
															{owner === true && g.dummy !== 1 &&
																<>
																	<OverlayTrigger placement="top" key="overlay-2" overlay={<Tooltip id="tooltip2">Edit Schedule Entry</Tooltip>}>
																		<FontAwesomeIcon icon="gear" onClick={()=>this.scheduleEdit(k)} />
																	</OverlayTrigger>&nbsp;&nbsp;
																</>
															}
															{g.recurring === 1 &&
																<OverlayTrigger placement="top" key="overlay-3" overlay={<Tooltip id="tooltip3">Recurring Event</Tooltip>}>
																	<FontAwesomeIcon icon="redo" />
																</OverlayTrigger>
															}
														</div>
														{/*isLocal!==true &&
															<OverlayTrigger placement="top" key="overlay-5" overlay={<Tooltip id="tooltip5">Your Local Timezone</Tooltip>}>
																<span>{moment(g.start).format("h:mm A")} {user.user.user.id===2&&`(${g.id})`}</span>
															</OverlayTrigger>
														*/}
													</div>
												</div>
											</div>
											<div className="card-body p-1">
												<div className="row gx-0">
													<div className="pl-2" style={{width: 60, height: 40, textAlign: 'center'}}>

														
															
														

														<img src={g.avatar} width="50" height="50" alt="Profile" style={{border: '1px solid #000000', borderRadius: 5}} />
													</div>
													<div className="col ps-2">
														<span className="scheduler-dj">
															{past===true?
																<><FontAwesomeIcon icon="user" /> DJ: <Link to={`/profile/${g.username}`}>{g.djtitle?g.djtitle:g.title?g.title:g.username}</Link></>
															:
																<><FontAwesomeIcon icon="user" /> DJ: {g.djtitle?g.djtitle:g.title?g.title:g.username}</>
															}
														</span>
														<br />
														{g.cancelled===0 ?
															<Genres genres={g.genres.length>0?g.genres:g.defaultgenres} />
														:
															<><FontAwesomeIcon icon={['far', 'clock']} /> Cancelled</>
														}
														{g.cancelled===1 &&
															<div style={{position: 'absolute', right: 45, top: 0}}>
																{(this.state.prepare.isAdmin===true)?
																	<Button size="sm" onClick={(f)=>{this.setState({date_dj: this.state.loop_inner[e]})}}>Book Slot</Button>
																:
																	<Button size="sm" onClick={()=>this.addEvent(this.state.loop_inner[e])}>Book Slot</Button>
																}
																{/*<Button size="sm" onClick={()=>this.changeEvent(this.state.loop_inner[e], g.id)}>Book Slot</Button>*/}
															</div>
														}
													</div>
												</div>
											</div>
										</div>
											{past===false&&owner===true&&
												<div
													id={`e${g.id}`}
													className="scheduler-tile-extend"
													draggable={!past&&owner?true:false}
													onDragStart={!past&&owner?(f)=>this.scheduleHold(f, 1, g.id, g.uid, date, Math.ceil((dateLocal(g.end) - dateLocal(g.start))/1800)):{}}
													onTouchStart={(f)=>this.touchHold(f, this.state.loop_inner[e])}
												>
													<OverlayTrigger placement="top" key="extend" overlay={<Tooltip id="tooltip1">Extend your slot</Tooltip>}>
														<FontAwesomeIcon id={`e${g.id}`} icon="caret-down" />
													</OverlayTrigger>
												</div>
											}
										</div>
									</div>
								)
							}
							return null;
						});

						
						//let past = (Math.floor(Date.now()/1000) > this.state.loop_inner[e]);
						let _past = (Math.floor(Date.now()/1000) - this.state.event.length*60 > this.state.loop_inner[e]);
						

						if( !found && !_past && e % this.state.loop_block === 0 /*&& Math.abs((Math.floor(new Date(this.state.event.start)/1000)-this.state.loop_inner[e]) % (this.state.event.length*60)) === 0*/ ) {
							//let date = (this.state.event.date + (j/2+this.state.event.start)*60*60);
							if( this.state.dragHover.ctime === 0 || Math.floor(Date.now()) < this.state.dragHover.ctime + 500 ) {
								return (
									<div className="scheduler-tile-book">&nbsp;&nbsp;
										{this.state.prepare.isAdmin===true?
											<Button size="sm" onClick={(f)=>{this.setState({date_dj: this.state.loop_inner[e]})}}>Book Slot</Button>
										:
											<Button size="sm" onClick={()=>this.addEvent(this.state.loop_inner[e])}>Book Slot</Button>
										}
									</div>
								);
							}
						}

						return y;

					})()}
					
					{this.state.loop_inner[e] === this.state.loop_inner[this.state.loop_inner.length-2] &&
						<></>
					}

				</div>
			)
		})

	let days = ['Sunday\'s', 'Monday\'s', 'Tuesday\'s', 'Wednesday\'s', 'Thursday\'s', 'Friday\'s', 'Saturday\'s'];
	let content = `${days[new Date(this.state.event.start).getDay()]} ${this.state.event.showname} - ${moment(new Date(this.state.event.start)).format("DD MMM, YYYY")} [br]`;
	let previous = 0;
	for( let e in this.state.loop_inner ) {
		//if( e % (this.state.loop_block===3?3:2) === 0 ) {
			//let pdate = new Date(this.state.loop_inner[e]*1000);
			//let perthStart = time.format(pdate);

			let found = false;
			//let start = 0;
			for( let i in this.state.event.events ) {
				
				if( this.state.loop_inner[e] >= Math.floor(new Date(this.state.event.events[i].start)/1000) &&
						this.state.loop_inner[e] < Math.floor(new Date(this.state.event.events[i].end)/1000) ) {
					
					
					found = this.state.event.events[i];
					//start = this.state.event.events[i].start;
				}
			}

			

			if( found && found.cancelled===0 ) {
				if( found.id !== previous ) {
					//let pdate = new Date(found.start);
					//content = `${content}${time.format(pdate)} - ${found.djtitle?found.djtitle:found.title?found.title:found.username}[br]`;
					previous = found.id;
				}
			} else {
				if( previous !== 0 || e % (this.state.loop_block===3?3:2) === 0 ) {
					//content = `${content}${time.format(pdate)}[br]`;
					previous = 0;
				}
			}

			

			
			/*
				if( found !== false ) {
					
					content = content + ` - ${found}`;
					
				}
				content = content + '[br]';
		//}*/
		
	}
		
/*
		//const content = 
      Object.keys(this.state.loop_inner).map((e,i) => {

				let pdate = new Date(this.state.loop_inner[e]*1000);
				let perthStart = time.format(pdate);

				if( i % (this.state.loop_block===3?3:2) === 0 ) {

					let found = false;
					for( let i in this.state.event.events ) {
						
						if( this.state.loop_inner[e] >= Math.floor(new Date(this.state.event.events[i].start)/1000) &&
								this.state.loop_inner[e] < Math.floor(new Date(this.state.event.events[i].end)/1000) ) {
							
							found = this.state.event.events[i].username;
						}
					}


					return (
						<React.Fragment id={i}>
							{perthStart}

							{found!==false &&
								<>
									&nbsp;- {found}
								</>
							}

						</React.Fragment>
					)
				}
			});
			*/
		return (
			<>
				{Object.keys(this.state.event).length > 0 &&
					<div className="scheduler">
						<div className="scheduler-header">
							
						</div>
						<div className="scheduler-body">
							{zones}
							{/*}
							<div className="scheduler-intervals" style={{width: true?300:150}}>
								<div className="scheduler-date" style={{height:40}}><b>Time ({/*zone*})</b></div>
									{outer_local}
								<div className="scheduler-date" style={{height:40}}></div>
							</div>*/}
							{/*isLocal!==true &&
								<div className="scheduler-intervals">
									<div className="scheduler-date" style={{height:40}}><b>Perth (GMT+8)</b></div>
										{outer_perth}
									<div className="scheduler-date" style={{height:40}}></div>
								</div>
							}*/}
							<div className="scheduler-panel">
								<div className="scheduler-date" style={{height:40}}>
									<b>DJ Booking</b>
									<div className="scheduler-date-add">
										{this.state.prepare.isAdmin &&
											<>
												<OverlayTrigger placement="top" key="post-messenger" overlay={<Tooltip id="postmessenger">Posting to messenger</Tooltip>}>
													<FontAwesomeIcon icon={['fab', 'facebook-messenger']} onClick={()=>this.messenger()} />
												</OverlayTrigger>&nbsp;&nbsp;
											</>
										}
										<OverlayTrigger placement="top" key="increase-start" overlay={<Tooltip id="tooltip1">Add additional starting hours</Tooltip>}>
											<FontAwesomeIcon icon="circle-plus" onClick={()=>this.increaseStart()} />
										</OverlayTrigger>&nbsp;&nbsp;
										<OverlayTrigger placement="top" key="schedule-info" overlay={<Tooltip id="scheduleinfo">Schedule Booking Info</Tooltip>}>
											<FontAwesomeIcon icon="circle-info" onClick={()=>this.booking()} className="pointer" />
										</OverlayTrigger>
									</div>
								</div>
								{inner_djs}
								<div className="scheduler-date" style={{height:40}}>
									<div className="scheduler-date-add" onClick={()=>this.increaseEnd()}>
										<OverlayTrigger placement="top" key="increase-end" overlay={<Tooltip id="tooltip1">Add additional ending hours</Tooltip>}>
											<FontAwesomeIcon icon="circle-plus"/>
										</OverlayTrigger>
									</div>
								</div>
							</div>
							
						</div>
						<div className="scheduler-footer">
						</div>
					</div>
				}
				{this.state.scheduleedit.organiser!==false && <ScheduleEdit show={this.state.scheduleedit.organiser>0} close={this.close} schedule={this.state.event.events[this.state.scheduleedit.id]} service={this.state.service} showname={this.state.event.showname} prepare={this.state.prepare} /> }

				<Modal
     			show={this.state.date_dj>0?true:false}
      		size="md"
      		aria-labelledby="contained-modal-title-vcenter"
					onHide={()=>this.addEvent(0)}
      		centered
    		>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Select DJ
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						
						<div className="scheduler-bookslot">
								
								<ButtonGroup className="mb-2" size="sm">
									<Button onClick={()=>this.recordings(false)} variant={this.state.recordings===true?'outline':'primary'}>DJ'S</Button>
									<Button onClick={()=>this.recordings(true)} variant={this.state.recordings===true?'primary':'outline'}>Recurrings</Button>
								</ButtonGroup>
								
								{this.state.recordings===true?replays:djs}
		
							</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={()=>this.addEvent(0)}>Close</Button>
					</Modal.Footer>
				</Modal>
				
				<Modal
     			show={this.state.messenger}
      		size="md"
      		aria-labelledby="contained-modal-title-vcenter"
					onHide={()=>this.messenger()}
      		centered
    		>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Facebook Messenger
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						Copying schedule to facebook messenger:<br /><br />
						<CopyBox content={content} />
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={()=>this.messenger()}>Close</Button>
					</Modal.Footer>
				</Modal>

				<Modal
     			show={this.state.scheduletime}
      		size="lg"
      		aria-labelledby="contained-modal-title-vcenter"
					onHide={()=>this.scheduleTime()}
      		centered
    		>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Schedule Booking Times
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col xs={6}>
								<strong>Starting Time:</strong><br />
								{/*(() => {
									let dateCheck = new Date();
									let check = parseInt(hour.format(dateCheck));
									let isLocal = dateCheck.getHours() === check;
									let slots = [];
									let starttime = Math.floor(new Date(this.state.event.start)/1000);
									for( let i = starttime - 60 * 60 * 3; i < starttime + 60 * 60 * 4; i += 60 * 60 ) {
										let pstart = time.format(new Date(i*1000));
										slots.push(
											<React.Fragment key={i}>
												<Form.Check // prettier-ignore
													type={'radio'}
													id={`st-${i}`}
													value={i}
													name={'schedule-starttime'}
													label={isLocal===true?`- ${pstart}`:`- ${pstart} (${moment(i*1000).format("h:mm A")})`}
													className="pt-2"
													defaultChecked={i===starttime?true:false}
												/>
											</React.Fragment>
										);
									}
									return slots
								})()*/}
							</Col>
							<Col xs={6}>
								<strong>Ending Time:</strong>
								{/*(() => {
									let dateCheck = new Date();
									let check = parseInt(hour.format(dateCheck));
									let isLocal = dateCheck.getHours() === check;
									let slots = [];
									let endtime = Math.floor(new Date(this.state.event.end)/1000);
									for( let i = endtime - 60 * 60 * 3; i < endtime + 60 * 60 * 4; i += 60 * 60 ) {
										let pend = time.format(new Date(i*1000));
										slots.push(
											<React.Fragment key={i}>
												<Form.Check // prettier-ignore
													type={'radio'}
													id={`et-${i}`}
													value={i}
													name={'schedule-endtime'}
													label={isLocal===true?`- ${pend}`:`- ${pend} (${moment(i*1000).format("h:mm A")})`}
													className="pt-2"
													defaultChecked={i===endtime?true:false}
												/>
											</React.Fragment>
										);
									}
									return slots
								})()*/}
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={()=>this.scheduleTime(true)}>Save</Button>
						<Button onClick={()=>this.scheduleTime()}>Close</Button>
					</Modal.Footer>
				</Modal>

				<Modal
     			show={this.state.booking?.status}
      		size="lg"
      		aria-labelledby="contained-modal-title-vcenter"
					onHide={()=>this.booking()}
      		centered
    		>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Schedule Booking Information
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<strong>Am I required to pre-book my slots ?</strong>
						<p>
							Yes, you must book in your slot before you start streaming
						</p>
						
						<strong>What if i forget to book my set ?</strong>
						<p>
							If you start streaming without a booking we will send you an email asking which service you wish to stream to, and if you start streaming without a booking then you can ignore the email.
						</p>
						<strong>How early can I start without changing my booking ?</strong>
						<p>
							You can start streaming upto 90 minutes early without changing your booking.
						</p>
						<strong>How does the handover work ?</strong>
						<p>
							Traditional manual handovers are in place where the first DJ will disconnect before the new DJ is arrived to start streaming. Please follow the instructions from your Owner/Admins in regards to handovers.
						</p>
						<strong>Previous DJ has playing past their set time and admins are not available ?</strong>
						<p>
							Please just start streaming and the system will kick the previous DJ off and start streaming our stream.
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={()=>this.booking()}>Close</Button>
					</Modal.Footer>
				</Modal>
			</>
		)
	}
}
	